import React, { useEffect } from "react";
import { Form, Input, Modal } from "antd";
import { useForm } from "antd/es/form/Form";

type Props = {
  title: string;
  isOpen: boolean;
  handleOk: (value?: any) => void;
  handleCancel?: () => void;
  loading?: boolean;
  items: { label: string; name: string; type: string }[];
  initialValues?: any;
};

const SimpleEditModal: React.FC<Props> = (props) => {
  const [form] = useForm();

  useEffect(() => {
    if (!props.isOpen) return;
    form.resetFields();
    if (props.initialValues) form.setFieldsValue(props.initialValues);
  }, [form, props.initialValues, props.isOpen]);

  return (
    <Modal
      title={props.title}
      open={props.isOpen}
      onOk={() => {
        props.handleOk(form.getFieldsValue());
        form.resetFields();
      }}
      confirmLoading={props.loading}
      onCancel={() => {
        form.resetFields();
        props.handleCancel?.();
      }}
    >
      <Form form={form}>
        {props.items?.map((item) => (
          <Form.Item key={item.name} name={item.name} label={item.label}>
            <Input type={item.type} />
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};

export default SimpleEditModal;
